import { CLINICIAN_TYPE } from "@src/constants";
import type { SecondaryFilters } from "@src/context/FilterContext";

/**
 * Checks if secondary filter is set to Prescriber.
 * Used across PrimaryFilters, SecondaryFilters, and ActiveFilters.
 */
export const isPrescriberProviderType = (
  secondaryFilter: Partial<SecondaryFilters> | undefined,
): boolean => {
  return secondaryFilter?.providerType === CLINICIAN_TYPE.PRESCRIBER;
};

/**
 * Determines if careFormat filter should be visible in FindProvider route.
 * Prescribers should not see/manage care format options.
 */
export const shouldShowCareFormatForFindProvider = (
  secondaryFilter: Partial<SecondaryFilters> | undefined,
  isTablet?: boolean,
  isMobile?: boolean,
): boolean => {
  // Hide for Prescriber always
  if (isPrescriberProviderType(secondaryFilter)) {
    return false;
  }
  // On desktop (neither tablet nor mobile), don't show in primary filters
  if (!isTablet && !isMobile) {
    return false;
  }
  return true;
};

/**
 * Determines if careFormat should be excluded from filter counts/display in ActiveFilters.
 * Excludes careFormat for Prescriber or when the viewport is wide enough that Service type
 * is already shown in PrimaryFilters (above the wide-tablet breakpoint).
 */
export const shouldExcludeCareFormatFromDisplay = (
  secondaryFilter: Partial<SecondaryFilters> | undefined,
  isWideTabletMax: boolean,
): boolean => {
  return !isWideTabletMax || isPrescriberProviderType(secondaryFilter);
};
